const grids = {
  container: '120rem',
  gutterDesktop: '24px',
  gutterPhone: '16px',
  gutterTablet: '20px'
}

export default grids
